module.exports = __webpack_public_path__ + "img/za.2b0734e4.svg";